var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscapeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 186,
    viewBox: "0 0 242 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.639 34.4902L89.6672 18.5867C89.097 18.5466 88.6027 18.9798 88.566 19.5565L88.0748 26.5488C83.6937 25.8398 73.844 25.488 65.2471 34.0849C54.9872 44.3448 57.9467 58.9465 57.9467 58.9465L58.0838 60.1814C58.0838 60.1814 59.6907 48.4265 70.0958 43.4033C76.9096 40.115 83.0329 41.1321 86.9476 42.5336L86.4706 49.3115C86.4316 49.8906 86.864 50.3932 87.4354 50.4368L105.586 36.9175C106.13 36.5638 106.618 36.3778 106.654 35.8014C106.695 35.2277 106.128 34.9554 105.639 34.4902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.88896e-07 180.96C-8.45715e-08 183.346 1.93477 185.281 4.32142 185.281L180.96 185.281C183.346 185.281 185.281 183.346 185.281 180.96L185.281 76.7053C185.281 74.3187 183.346 72.3839 180.96 72.3839L4.32142 72.3839C1.93476 72.3839 -4.85033e-06 74.3187 -4.746e-06 76.7054L-1.88896e-07 180.96ZM5.40178 77.2455L5.40179 180.42L164.214 180.42L164.214 77.2455L5.40178 77.2455Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.423 0C131.036 0 129.102 1.93477 129.102 4.32142V180.96C129.102 183.346 131.036 185.281 133.423 185.281H237.677C240.064 185.281 241.999 183.346 241.999 180.96V4.32143C241.999 1.93477 240.064 0 237.677 0H133.423ZM237.137 5.40179H133.963V164.214H237.137V5.40179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeError);
export default __webpack_public_path__ + "static/media/landscape-error.fbbc7c2c964ff7a06feffc2ee9d55e6d.svg";
export { ForwardRef as ReactComponent };